import { useRef, useState, useReducer, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import pdf from "../../../../assets/MOCK_OD/img/pdf-svgrepo-com.svg";

import "../../../../assets/UFC_DC_V1/scss/modules/custom.scss";
import "../../../../assets/UFC_DC_V1/scss/modules/anim.scss";
import "../../../../assets/UFC_DC_V1/scss/modules/checklist.scss";
import "../../../../assets/UFC_DC_V1/scss/modules/personaldetails.scss";
import "../../../../assets/UFC_DC_V1/scss/modules/questionnaire.scss";

import logo_white from "../../../../assets/UFC_DC_V1/img/logo-white.png";
import bg_money_sml from "../../../../assets/UFC_DC_V1/img/bg-money-sml.png";
import ssl from "../../../../assets/UFC_DC_V1/img/ssl.png";

import { useFollowupUserSignature } from "../../../../Hooks/useFollowupUserSignature";
import { useUpdateMilestone } from "../../../../Hooks/useUpdateMilestone";

// import Loa from "../UFC_DC_V2/Loa";
// import Vq from "../UFC_DC_V2/Vq";
// import Tob from "../UFC_DC_V2/Tob";
// import Decl from "../UFC_DC_V2/Decl";
// import Dsar from "../UFC_DC_V2/Dsar";

import Loa from "../../Layouts/UFC_DC_RF_V1/Loa";
import Tob from "../../Layouts/UFC_DC_RF_V1/Tob";
import Decl from "../../Layouts/UFC_DC_RF_V1/Decl";
import Vq from "../../Layouts/UFC_DC_RF_V1/Vq";
import Dsar from "../../Layouts/UFC_DC_RF_V1/Dsar";

import CheckBox2 from "./Checkbox2";
import { Accordion } from "react-bootstrap";
import { useFollowupUserQuestions } from "../../../../Hooks/useFollowupUserQuestions";
import { usePageLoad } from "../../../../Hooks/usePageLoad";
import { getPageName } from "../../../../Constants/PageNames";

const initialState = {
  isChecked: false,
  isAgreed: false,
  isCanvasEmpty: false,
  isValid: false,
  isConfrim: true,
};
const signatureReducer = (state, action) => {
  switch (action.type) {
    case "signPadChange": {
      return {
        ...state,
        isCanvasEmpty: action.payload.value,
      };
    }
    case "privacyAgreed": {
      return {
        ...state,
        isAgreed: action.payload.value,
      };
    }
    case "validSignature": {
      return {
        ...state,
        isValid: action.payload.value,
      };
    }
    case "confirmChecked": {
      return {
        ...state,
        isConfrim: action.payload.value,
      };
    }
    default:
      return state;
  }
};
const Signature = ({
  allFollowupData,
  uuid,
  cfirstName,
  removeFromPending,
  setUserSign,
}) => {
  const [state, dispatch] = useReducer(signatureReducer, initialState);
  const { saveFollowupUserSignature, isLoading } = useFollowupUserSignature();
  const { saveFollowupUserQuestions } = useFollowupUserQuestions();
  const [isChecked, setIsChecked] = useState(true);
  const signPadRef = useRef();
  const [signatureWrapWidth, setSignatureWrapWidth] = useState(0);
  const [signatureWrapHeight, setSignatureWrapHeight] = useState(0);
  const { updateMilestone } = useUpdateMilestone();
  const flp_source = allFollowupData.atp_sub6;
  const signatureWrapRef = useRef();
  const { savePageLoad, calledOnce } = usePageLoad();
  const split_name = localStorage.getItem("split_name");
  const query_string = localStorage.getItem("queryString");
  const [checkboxtwo, setCheckboxtwo] = useState(true);
  const [showloa, setShowLoa] = useState(false);
  const [questionPdf, setQuestionPdf] = useState(false);
  const [showTOB, setShowTob] = useState(false);
  const [showDecl, setShowDecl] = useState(false);
  const [showDsar, setShowDsar] = useState(false);
  const checkboxOneRef = useRef(null);
  const checkboxTwoRef = useRef(null);
  const [showDoc, setShowDoc] = useState(false);


  const storeFollowupQuestionnire = async () => {
    let question_data = {
        question_id: 114,
        option_id: 318,
        answer_text: null,
        input_answer: null,
      };

    const response = await saveFollowupUserQuestions(
      question_data,
      allFollowupData,
      "followup_question_store"
    );
  };


  useEffect(() => {
    if (!!uuid && !calledOnce) {
      const data = {
        uuid,
        page_name: getPageName("sign"),
        status: "visited",
        source: flp_source,
      };
      (async () => {
        await savePageLoad(
          uuid,
          data,
          "visited_status",
          split_name,
          query_string,
          allFollowupData
        );
      })();
    }
  }, [uuid, calledOnce]);

  const handlePageLoad = async () => {
    const data = {
      uuid,
      page_name: getPageName("sign"),
      status: "completed",
      source: flp_source,
    };
    await savePageLoad(
      uuid,
      data,
      "visited_status",
      split_name,
      query_string,
      allFollowupData
    );
  };


  const showLoapdf = () => {
    setShowLoa("show");
  };

  const showQuestpdf = () => setQuestionPdf("show");
  const showTobpdf = () => setShowTob("show");
  const showDeclpdf = () => setShowDecl("show");
  const showDsarpdf = () => setShowDsar("show");


  useEffect(() => {
    if (!isChecked) {
      dispatch({ type: "privacyAgreed", payload: { value: false } });
    }
    if (isChecked) {
      dispatch({ type: "privacyAgreed", payload: { value: true } });
    }
  }, [isChecked]);

  useEffect(() => {
    if (!checkboxtwo) {
      dispatch({ type: "confirmChecked", payload: { value: false } });
    }

    if (checkboxtwo) {
      dispatch({ type: "confirmChecked", payload: { value: true } });
    }
  }, [checkboxtwo]);


  const handleClick = async () => {
    try {
      const signPad = signPadRef.current;
      if (signPad.isEmpty()) {
        signatureWrapRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        return dispatch({ type: "signPadChange", payload: { value: true } });
      }
      if (!isChecked) {
        checkboxOneRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        return dispatch({ type: "privacyAgreed", payload: { value: false } });
      }
      if (!checkboxtwo) {
        checkboxTwoRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        return dispatch({ type: "confirmChecked", payload: { value: false } });
      }
      const rpdata = signPad.toData();
      var signLength = 0;
      for (var i = 0; i < rpdata.length; i++) {
        signLength += Object.keys(rpdata[i]).length;
      }
      if (signLength > 13) {

        setUserSign(signPad.getCanvas().toDataURL("image/png"));
        const response = await saveFollowupUserSignature(
          signPad.getCanvas().toDataURL("image/png"),
          allFollowupData,
          "followup_user_signature"
        );

        storeFollowupQuestionnire();

        if (response.data.status === "Success") {
          updateMilestone(uuid, "signature", flp_source);
          removeFromPending("signature");
          handlePageLoad();

        }
      } else {
        return dispatch({ type: "validSignature", payload: { value: true } });
      }
    } catch (e) {
      console.warn(e);
    }
  };

  useEffect(() => {
    function handleResize() {
      setSignatureWrapWidth(signatureWrapRef.current.clientWidth);
      setSignatureWrapHeight(signatureWrapRef.current.clientHeight);
    }
    setSignatureWrapWidth(signatureWrapRef.current.clientWidth);
    setSignatureWrapHeight(signatureWrapRef.current.clientHeight);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const clearSign = () => {
    if (signPadRef.current) signPadRef.current.clear();
  };
  return (
    <>
      <div className="UFC_DC_V1">
        <form name="split_form" id="user_form" method="POST" autoComplete="off">
          <section className={`banner  parallax-container h-100`}>
            <div className="d-lg-none d-md-none d-sm-block d-block money-bg-mobile">
              <img src={bg_money_sml} alt="" />
            </div>
            <div className="container">
              <div>
                <div className="brand">
                  <div className="logo pt-3">
                    <a href="index.html">
                      {" "}
                      <img src={logo_white} height="60" alt="" />
                    </a>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
            <div className="container pt-5 px-lg-2 px-md-2 px-sm-0 px-0  ">
              <div className="inner-section  forms-body forms-body1  pb-3 sginature  mb-0 pb-0  ">
                <div className="p-2 d-flex  text2-info justify-content-center mb-4 rounded-2">
                  <div className="pe-2">
                    <i className="bi bi-info-circle"></i>
                  </div>
                  <div>Sign below to initiate your claim</div>
                </div>

                <h1 className="  text-greatnews">
                  {" "}
                  <span className="text-danger">GREAT NEWS,</span>{" "}
                  {cfirstName ? cfirstName : ""}
                </h1>
                <div className="fw-bold ownedupto mb-2">
                  You could be owed <span>£1000’s</span>
                </div>
                <p>
                  {" "}
                  Please provide your signature as in records. Your signature
                  will authorise us to draft the claim application on your
                  behalf.
                </p>

                <div ref={checkboxTwoRef}>
                  <CheckBox2
                    dataId="checkbox2"
                    anchorText=""
                    anchorStyle=""
                    href=""
                    onChange={() => {
                      setCheckboxtwo((prev) => !prev);
                      dispatch({
                        type: "confirmChecked",
                        payload: { value: checkboxtwo },
                      });
                    }}
                    className="shadow-none checkinput me-2"
                    value={checkboxtwo}
                    checked={checkboxtwo}
                    CheckBoxText={
                      <>
                        I confirm that I had not maintained a positive balance for a
                        significant period of <strong> time on my overdraft</strong>.
                        This ought to have made the bank aware of my financial
                        difficulties
                        <strong>
                          and that I could not clear the overdraft in a reasonable
                          amount of time
                        </strong>
                        .&nbsp;
                        <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowDoc(!showDoc);
                        }}
                      >
                        View Claim Documents
                      </a>
                      </>
                    }
                  />

                  {showDoc && (
                  <div className="side-toggle bg-white px-3 py-2 mb-3 rounded-3 shadow-sm">
                    <ul className="links ps-0 mt-0 mb-0">
                      <li>
                        <a className="btn btn-link fnt-sml" onClick={showLoapdf}>
                          <img src={pdf} />
                          Letter of Authority
                        </a>
                      </li>
                      <li>
                        <a className="btn btn-link fnt-sml" onClick={showQuestpdf}>
                          <img src={pdf} />
                          Questionnaire
                        </a>
                      </li>
                      <li>
                        <a className="btn btn-link fnt-sml" onClick={showTobpdf}>
                          <img src={pdf} />
                          Terms of Business Agreement
                        </a>
                      </li>
                      <li>
                        <a className="btn btn-link fnt-sml" onClick={showDeclpdf}>
                          <img src={pdf} />
                          Declaration Form
                        </a>
                      </li>
                      <li>
                        <a className="btn btn-link fnt-sml" onClick={showDsarpdf}>
                          <img src={pdf} />
                          DSAR Letter of Authority
                        </a>
                      </li>
                    </ul>
                  </div>
                   )} 
                  {state.isConfrim === false && (
                    <span className="error_msg text-center">
                      Please tick to accept in order to proceed
                    </span>
                  )}
                </div>


              </div>
            </div>
            <div className="container    px-lg-2 px-md-2 px-sm-0 px-0  ">
              <div className="inner-section  forms-body forms-body2 pb-5 sginature signboxsection  pt-0 px-lg-5 px-md-5 px-sm-0 px-0">
                <div
                  className="signbox position-relative"
                  ref={signatureWrapRef}
                >
                  <SignatureCanvas
                    canvasProps={{
                      id: "myID",
                      className: "w-100",
                      width: signatureWrapWidth,
                      height: 350,
                    }}
                    ref={signPadRef}
                    onEnd={() => {
                      if (!signPadRef.current.isEmpty()) {
                        dispatch({
                          type: "signPadChange",
                          payload: { value: false },
                        });
                        dispatch({
                          type: "validSignature",
                          payload: { value: false },
                        });
                      }
                    }}
                  />
                  <input
                    type="button"
                    id=""
                    name=""
                    className="sign-clear position-absolute border-0 rounded-2 px-4 py-2 text-white"
                    value="Clear"
                    onClick={clearSign}
                  />
                </div>
                {state.isCanvasEmpty && (
                  <div
                    className="sign_msg col-12 text-center sign_msg mb-3"
                    id="signatures_required"
                  >
                    Signature is required!
                  </div>
                )}
                {state.isValid && (
                  <div
                    className="sign_msg col-12 text-center sign_msg"
                    id="signatures_valid"
                  >
                    Draw valid signature!
                  </div>
                )}
                <div className="px-lg-0 px-md-0 px-sm-4 px-4 ">
                  <div ref={checkboxOneRef} className="d-flex gap-2 checkbox-set mb-3 mt-3">
                    <CheckBox2
                      dataId="checkbox1"
                      anchorText=""
                      anchorStyle=""
                      href=""
                      onChange={() => {
                        setIsChecked(!isChecked);
                        dispatch({
                          type: "privacyAgreed",
                          payload: { value: isChecked },
                        });
                      }}
                      className="shadow-none check-input me-2"
                      value={isChecked}
                      checked={isChecked}
                      CheckBoxText={
                        <>
                          I agree to the processing of my personal data as outlined below.
                          I/We understand that <strong>TMS Legal</strong> will receive an
                          Electronic Credit Report from CheckBoard and a soft footprint will
                          be retained on my/our credit file.
                        </>
                      }
                    />

                  </div>
                  {state.isAgreed === false && (
                    <span className="error_msg text-center">
                      Please tick to show your authorisation for us to proceed
                    </span>
                  )}
                  <div className="bg-white">
                    <div className="row pt-3 pb-3 mt-4">
                      <div
                        className="col-12 d-none d-md-block"
                        onClick={handleClick}
                      >
                        <button
                          type="button"
                          className="btn-sign   fw-bold  w-100  personinfo"
                        >
                          <span className="btntext"> Submit </span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="sign-blowtext">
                    <div className="text-cp">
                      <p className="fw-semibold ">
                        We respect your privacy and give you control over your
                        personal data. Please review the information below
                        before giving your consent.
                      </p>
                      <p className="fw-semibold">
                        {" "}
                        By ticking the box, you agree to the following :{" "}
                      </p>
                    </div>

                    <p className="sig-title mb-1">
                      Consent for Data Processing
                    </p>
                    <p>
                      You consent to TMS Legal using your data to represent you
                      in any Responsible Lending and/or Mis-Sold Car Finance
                      claims.
                    </p>
                    <p className="sig-title mb-1">Withdrawal of Consent</p>
                    <p>
                      You can withdraw consent at any time by contacting us.
                      Withdrawal of consent will not affect the legality of any
                      processing carried out before your request.
                    </p>

                    <p className="sig-title mb-1">Optional Consent</p>
                    <p>
                      Your consent is voluntary and not a condition for
                      accessing our services.
                    </p>

                    {/* <Accordion>
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          View Claim Documents
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="mt-2 d-flex">
                            <i className="bi bi-box-arrow-up-right pt-2"></i>
                            <Loa />
                          </div>
                          <div className="mt-2 d-flex">
                            <i className="bi bi-box-arrow-up-right pt-2"></i>
                            <Vq />
                          </div>
                          <div className="mt-2 d-flex">
                            <i className="bi bi-box-arrow-up-right pt-2"></i>
                            <Tob />
                          </div>
                          <div className="mt-2 d-flex">
                            <i className="bi bi-box-arrow-up-right pt-2"></i>
                            <Decl />
                          </div>
                          <div className="mt-2 d-flex">
                            <i className="bi bi-box-arrow-up-right pt-2"></i>
                            <Dsar />
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion> */}
                  </div>

                  <div className="bg-white">
                    <div className="row pt-3 pb-3 mt-4">
                      <div
                        className="col-12 stickyBtnV2 d-block d-md-none"
                        onClick={handleClick}
                      >
                        <button
                          type="button"
                          className="btn-sign   fw-bold  w-100  personinfo btn-"
                        >
                          <span className="btntext"> Submit </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className=" mb-3 d-lg-flex justify-content-center  align-items-center text-center mt-5">
                  <div className=" pe-lg-3 pe-md-3 ps-sm-0 pe-0 mb-lg-0 mb-md-0 mb-sm-4  mb-4">
                    {" "}
                  </div>
                  <div>
                    {" "}
                    <img height="28" src={ssl} alt="" />{" "}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </form>
      </div>
      {showloa && <Loa setShowLoa={setShowLoa} showloa={showloa} />}

      {questionPdf && (
        <Vq close={() => setQuestionPdf(false)} />
      )}

      {showTOB && <Tob showTOB={showTOB} setShowTob={setShowTob} />}
      {showDecl && <Decl showDecl={showDecl} setShowDecl={setShowDecl} />}

      {showDsar && <Dsar showDsar={showDsar} setShowDsar={setShowDsar} />}
    </>
  );
};
export default Signature;
